import { DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD } from 'ducks/drawers/ids'
import { DRAWER_TYPE_CHANNELS_EMAIL_FORWARD } from 'ducks/drawers/types'

export default {
  google: {},
  // This is to indicate that facebook and instagram are valid options, but there are
  // no settings for them (aka the flow ends here)
  facebook: {},
  instagram: {},
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
  },
}
